<template>
  <div class="main user-layout-register">
    <a-form ref="formRegister" :autoFormCreate="(form)=>{this.form = form}" id="formRegister">
      <a-form-item
        label="账号"
        fieldDecoratorId="username"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '账号不能为空'}, { validator: this.checkUsername }], validateTrigger: ['change', 'blur'], validateFirst: true}">
        <a-input type="text" autocomplete="false" placeholder="建议使用手机号或18位身份证号/护照/其他证件号"></a-input>
      </a-form-item>

      <a-form-item
        label="用户姓名"
        fieldDecoratorId="realname"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '姓名不能为空'}], validateTrigger: ['change', 'blur'], validateFirst: true}">
        <a-input  type="text" autocomplete="false" placeholder="应与身份证上的姓名保持一致"></a-input>
      </a-form-item>

      <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }" v-show="!_isMobile()">
            <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
            <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor "/>
            <div style="margin-top: 10px;">
              <span>请至少输入 8 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-item
          label="密码"
          fieldDecoratorId="password"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '至少8位密码，区分大小写' }, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur'], validateFirst: true}">
          <a-input  type="password" @click="handlePasswordInputClick" autocomplete="false" placeholder="请输入密码长度8~16位"></a-input>
        </a-form-item>
      </a-popover>

      <a-form-item
        label="确认密码"
        fieldDecoratorId="password2"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '至少8位密码，区分大小写' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur'], validateFirst: true}">
        <a-input  type="password" autocomplete="false" placeholder="确认密码"></a-input>
      </a-form-item>
      <a-form-item
        label="手机号码"
        fieldDecoratorId="phone"
        :fieldDecoratorOptions="{rules: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }, { validator: this.handlePhoneCheck } ], validateTrigger: ['change', 'blur'], validateFirst: true}">
        <a-input  placeholder="可用于找回密码，请准确填写">
        </a-input>
      </a-form-item>
      <a-row :gutter="16" v-if="false">
        <a-col class="gutter-row" :span="16">
          <a-form-item
            fieldDecoratorId="captcha"
            :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur', validateFirst: true}">
            <a-input  type="text" placeholder="验证码">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <a-button
            class="getCaptcha"
            :readOnly="state.smsSendBtn"
            @click.stop.prevent="getCaptcha"
            v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"></a-button>
        </a-col>
      </a-row>

      <a-form-item>
        <a-button
          style="width: 150px"
          type="primary"
          htmlType="submit"
          class="register-button"
          :loading="registerBtn"
          @click.stop.prevent="handleSubmit"
          :readOnly="registerBtn">注册
        </a-button>
        <a @click="toLogin" class="forge-password" style="float: right;margin-right: 10px;line-height: 30px;" >
          立即登录
        </a>
      </a-form-item>

    </a-form>
  </div>
</template>

<script>
  import {mixinDevice} from '@/utils/mixin.js'
  import {getSmsCaptcha} from '@/api/login'
  import {getAction, postAction} from '@/api/manage'
  import {checkOnlyUser} from '@/api/api'
  import { jumpMixins } from "@/utils/jumpMixins"

  const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
  }
  const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
  }
  const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a',
  }
  export default {
    name: "Register",
    components: {},
    mixins: [mixinDevice, jumpMixins],
    data() {
      return {
        form: null,

        state: {
          time: 60,
          smsSendBtn: false,
          passwordLevel: 0,
          passwordLevelChecked: false,
          percent: 10,
          progressColor: '#FF0000'
        },
        registerBtn: false
      }
    },
    computed: {
      passwordLevelClass() {
        return levelClass[this.state.passwordLevel]
      },
      passwordLevelName() {
        return levelNames[this.state.passwordLevel]
      },
      passwordLevelColor() {
        return levelColor[this.state.passwordLevel]
      }
    },
    methods: {
      checkUsername(rule, value, callback) {
        var params = {
          username: value,
        };
        checkOnlyUser(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback("账号已存在!")
          }
        })
      },
      handlePasswordLevel(rule, value, callback) {
        let level = 0
        let reg = /^[\w]{8,}$/;
        if (!reg.test(value)) {
          callback(new Error('密码由8位以上数字、大小写字母组成!'))
        }
        // 判断这个字符串中有没有数字
        if (/[0-9]/.test(value)) {
          level++
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(value)) {
          level++
        }
        // 判断字符串中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(value)) {
          level++
        }
        this.state.passwordLevel = level
        this.state.percent = level * 30
        if (level >= 2) {
          if (level >= 3) {
            this.state.percent = 100
          }
          callback()
        } else {
          if (level === 0) {
            this.state.percent = 10
          }
          callback(new Error('密码强度不够'))
        }
      },

      handlePasswordCheck(rule, value, callback) {
        let password = this.form.getFieldValue('password')
        //console.log('value', value)
        if (value === undefined) {
          callback(new Error('请输入密码'))
        }
        if (value && password && value.trim() !== password.trim()) {
          callback(new Error('两次密码不一致'))
        }
        callback()
      },

      handlePhoneCheck(rule, value, callback) {
        var params = {
          phone: value,
        };
        checkOnlyUser(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback("手机号已存在!")
          }
        })
      },

      handlePasswordInputClick() {
        if (!this.isMobile()) {
          this.state.passwordLevelChecked = true
          return;
        }
        this.state.passwordLevelChecked = false
      },

      handleSubmit() {
        this.form.validateFields((err, values) => {
          console.log(values);
          if (!err) {
            var register = {
              username: values.username,
              realname: values.realname,
              password: values.password,
              email: values.email,
              phone: values.phone,
              smscode: values.captcha,
              address: values.address,
              school: values.school,
              identity: values.identity,
              role: 'student'
            };
            postAction("/sys/user/register", register).then((res) => {
              if (!res.success) {
                this.registerFailed(res.message)
              } else {
                this.$emit('success')
                this.$notification.success({
                  message: "提示",
                  description: `注册成功`,
                });
                //this.$router.push({name: 'login'})
                if(this.$route.query.backUrl){
                  this.$router.push({name: 'login', query: {backUrl:this.$route.query.backUrl}});
                }else{
                  this.$router.push({name: 'login'})
                }
              }
            })
          }
        })
      },

      // getCaptcha(e) {
      //   e.preventDefault()
      //   let that = this
      //   this.form.validateFields(['mobile'], {force: true}, (err, values) => {
      //       if (!err) {
      //         this.state.smsSendBtn = true;
      //         let interval = window.setInterval(() => {
      //           if (that.state.time-- <= 0) {
      //             that.state.time = 60;
      //             that.state.smsSendBtn = false;
      //             window.clearInterval(interval);
      //           }
      //         }, 1000);
      //         const hide = this.$message.loading('验证码发送中..', 0);
      //         const params = {
      //           mobile: values.mobile,
      //           smsmode: "1"
      //         };
      //         postAction("/sys/sms", params).then((res) => {
      //           if (!res.success) {
      //             this.registerFailed(res.message);
      //             setTimeout(hide, 0);
      //           }
      //           setTimeout(hide, 500);
      //         }).catch(err => {
      //           setTimeout(hide, 1);
      //           clearInterval(interval);
      //           that.state.time = 60;
      //           that.state.smsSendBtn = false;
      //           this.requestFailed(err);
      //         });
      //       }
      //     }
      //   );
      // },
      registerFailed(message) {
        this.$notification['error']({
          message: "注册失败",
          description: message,
          duration: 2,
        });

      },
      requestFailed(err) {
        this.$notification['error']({
          message: '错误',
          description: ((err.response || {}).data || {}).message || "请求出现错误，请稍后再试",
          duration: 4,
        });
        this.registerBtn = false;
      },
    },
    watch: {
      'state.passwordLevel'(val) {
        console.log(val)

      }
    }
  }
</script>
<style lang="less">
  .user-register {
    &.error {
      color: #ff0000;
    }
    &.warning {
      color: #ff7e05;
    }
    &.success {
      color: #52c41a;
    }
  }
  .user-layout-register {
    .ant-input-group-addon:first-child {
      background-color: #fff;
    }
  }
</style>
<style lang="less" scoped>
  .user-layout-register {
    & > h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }
    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    .register-button {
      width: 100%;
    }
    .login {
      float: right;
      line-height: 40px;
    }
  }
  /deep/.ant-form-item-label{
    line-height: 0;
  }
  /deep/.ant-form-item-control{
    line-height: 0;
  }
</style>